import { OnInit, Component } from "@angular/core";
import { DoctorBreadcrumbService } from '../../shared/breadcrumb.service';
import { ProviderStateService } from "src/app/services/provider-state.service";



@Component({
  selector: 'app-fetch-users',
  templateUrl: './fetch-users.component.html',
  styleUrls: ['./fetch-users.component.css', '../../../../../assets/css/custom-egd.css'],
})
export class FetchUsersComponent implements OnInit {
  slug: string = "";
  constructor(
    private readonly breadcrumbService: DoctorBreadcrumbService,
    private readonly providerstateService: ProviderStateService
  ) {
    
  }
 
  async ngOnInit() {
    this.slug = this.providerstateService.getProviderSlug();
    this.breadcrumbService.setItems([
      { label: 'Dashboard', routerLink:['/', this.slug, 'vendor'] },
      { label: 'User List' },
      { label: 'Vendor' }
    ]);
    
  }
}
